<template>
  <svg
    width="160"
    height="120"
    viewBox="0 0 160 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <g clip-path="url(#clip0)">
        <path
          d="M17.4295 120H152.095C160.308 109.209 160.884 92.603 157.212 79.5487C155.322 72.8316 151.84 66.5777 150.645 59.7001C148.987 50.1203 151.929 40.2317 150.639 30.5925C148.565 15.0141 134.606 2.18558 118.995 0.267243C103.384 -1.64516 87.3029 6.77654 78.9297 20.0802C75.4058 25.6867 72.5057 32.6058 66.26 34.8092C58.4039 37.5888 50.4348 31.2458 42.1984 29.957C34.6691 28.781 26.902 32.0832 21.4705 37.4225C16.0389 42.7617 12.7111 49.9243 10.649 57.2532C4.99159 77.3334 5.94241 102.581 17.4295 120Z"
          fill="#E5E5E5"
        />
        <path
          d="M134.553 88.8673H46.9708C45.39 88.8673 43.9163 89.6631 43.0546 90.9876L28.8636 112.79C28.3704 113.544 28.1089 114.429 28.1089 115.332C28.1089 117.91 30.2007 120 32.7798 120H148.744C151.323 120 153.415 117.91 153.415 115.332C153.415 114.429 153.154 113.544 152.66 112.79L138.469 90.9876C137.608 89.6631 136.134 88.8673 134.553 88.8673Z"
          fill="#949494"
        />
        <path
          d="M137.727 108.823L128.884 92.989C128.207 91.7715 126.923 91.0172 125.526 91.0172H50.3285C48.9557 91.0172 47.6899 91.7477 47.0006 92.9356L37.8192 108.793C37.2131 109.844 37.9678 111.163 39.1801 111.163H70.8899H86.632H91.6178H106.813H136.348C137.554 111.163 138.315 109.868 137.727 108.823Z"
          fill="#EFEFEF"
        />
        <path
          d="M141.25 101.007C141.601 102.314 140.793 103.412 139.444 103.454C138.095 103.495 136.722 102.474 136.371 101.167C136.021 99.8606 136.829 98.7619 138.178 98.7203C139.521 98.6788 140.9 99.7003 141.25 101.007Z"
          fill="#7F7F7F"
        />
        <path
          d="M153.409 115.332C153.409 117.91 151.317 120 148.738 120H32.7856C31.4961 120 30.3313 119.478 29.4815 118.634C28.6377 117.791 28.1147 116.621 28.1147 115.332C28.1147 114.863 28.1861 114.394 28.3287 113.948H153.201C153.344 114.394 153.409 114.863 153.409 115.332Z"
          fill="#7F7F7F"
        />
        <path
          d="M106.813 111.163C106.813 111.163 105.214 76.8999 131.51 66.9697C131.51 66.9697 133.822 93.482 117.088 111.163H106.813Z"
          fill="url(#paint0_linear)"
        />
        <path
          opacity="0.2"
          d="M117.087 111.163H112.803C126.845 96.3209 127.475 75.2607 127.315 68.8761C128.622 68.1694 130.019 67.528 131.504 66.9697C131.504 66.9756 133.822 93.482 117.087 111.163Z"
          fill="url(#paint1_linear)"
        />
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M131.51 66.9697C131.51 66.9697 117.907 84.11 112.464 111.163"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M124.017 78.937C124.017 78.937 127.945 77.7195 131.255 77.381"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M120.754 85.571C120.754 85.571 119.833 77.4047 120.231 73.9956"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M118.276 91.433C118.276 91.433 123.137 90.75 128.646 90.6253"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M115.887 98.1205C115.887 98.1205 112.066 89.7403 113.011 83.5933"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M113.926 104.832C113.926 104.832 117.693 103.371 123.921 101.832"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M113.064 108.354C113.064 108.354 108.536 101.731 108.167 97.283"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M115.59 111.163C115.59 111.163 115.59 82.6074 147.014 83.427C147.014 83.427 142.254 102.058 126.334 111.163H115.59Z"
          fill="url(#paint2_linear)"
        />
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M147.014 83.427C147.014 83.427 127.017 92.5376 120.76 111.163"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M137.108 89.6274C137.108 89.6274 140.679 89.283 144.631 89.8888"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M131.926 94.0996C131.926 94.0996 132.217 87.5725 134.208 85.0602"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M127.249 99.3023C127.249 99.3023 134.071 98.6549 138.813 99.8784"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M124.183 103.769C124.183 103.769 122.828 96.5406 124.753 90.3936"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M121.782 108.478C121.782 108.478 126.072 107.219 131.611 107.51"
            stroke="#FEFEFE"
            stroke-width="0.6868"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          opacity="0.2"
          d="M147.015 83.427C147.015 83.427 142.255 102.058 126.34 111.163H121.984C137.275 102.414 142.267 84.888 142.647 83.5102C144.032 83.4211 145.487 83.3854 147.015 83.427Z"
          fill="url(#paint3_linear)"
        />
        <path
          d="M116.648 107.433C116.684 108.847 116.03 110.296 114.972 111.163H100.526C98.933 109.767 97.9109 107.7 97.3225 105.646C96.5975 103.139 96.8887 100.366 98.101 98.0613C98.7309 96.8675 99.6045 95.7866 99.9551 94.4859C100.27 93.3337 100.145 92.1756 99.8482 91.0174C99.6699 90.3048 99.4262 89.5861 99.1766 88.8675C98.5051 86.9491 97.8039 85.0189 98.2555 83.1065C98.7844 80.8912 100.722 79.3233 101.869 77.3574C103.289 74.9283 103.449 71.9944 103.622 69.1852C103.794 66.376 104.044 63.4302 105.595 61.0842C107.146 58.7323 110.444 57.295 112.874 58.7204C114.77 59.837 115.501 62.2839 115.317 64.4814C115.127 66.6729 114.211 68.7219 113.534 70.8185C112.851 72.915 112.417 75.2253 113.189 77.2862C113.843 79.0263 115.299 80.4042 115.846 82.18C116.493 84.2587 115.798 86.4978 114.931 88.4874C114.877 88.6121 114.818 88.7428 114.77 88.8675C114.449 89.5802 114.122 90.2929 113.825 91.0174C113.35 92.1875 112.969 93.3812 112.91 94.6403C112.797 96.8794 113.724 99.0293 114.657 101.066C115.596 103.098 116.589 105.188 116.648 107.433Z"
          fill="url(#paint4_linear)"
        />
        <path
          opacity="0.25"
          d="M106.623 111.697C108.804 110.676 109.767 107.985 109.576 105.58C109.386 103.181 108.299 100.953 107.372 98.7321C106.445 96.5049 105.66 94.0877 106.112 91.718C106.457 89.9184 107.491 88.2971 107.74 86.4856C108.097 83.8368 106.724 81.1582 107.211 78.5331C107.639 76.2287 109.434 74.352 109.856 72.0417C110.218 70.052 109.517 68.0506 109.137 66.0609C108.756 64.0773 108.81 61.7491 110.295 60.3772"
          stroke="#FEFEFE"
          stroke-width="0.6868"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.2"
          d="M116.648 107.433C116.684 108.846 116.03 110.296 114.972 111.163H111.306C112.363 110.296 113.017 108.846 112.982 107.433C112.922 105.188 111.93 103.097 110.997 101.06C110.064 99.0232 109.143 96.8732 109.25 94.6341C109.309 93.375 109.689 92.1813 110.165 91.0113C110.456 90.2867 110.789 89.574 111.11 88.8613C111.163 88.7366 111.223 88.6059 111.27 88.4812C112.138 86.4857 112.827 84.2466 112.185 82.1738C111.638 80.398 110.183 79.0202 109.529 77.28C108.756 75.2132 109.196 72.9088 109.874 70.8123C110.551 68.7217 111.472 66.6668 111.656 64.4752C111.846 62.2837 111.116 59.8308 109.214 58.7143C109.089 58.643 108.958 58.5717 108.828 58.5123C110.171 58.0075 111.638 57.9838 112.88 58.7143C114.776 59.8308 115.507 62.2777 115.323 64.4752C115.133 66.6668 114.218 68.7158 113.54 70.8123C112.857 72.9088 112.423 75.2191 113.195 77.28C113.849 79.0202 115.305 80.398 115.852 82.1738C116.5 84.2525 115.804 86.4916 114.937 88.4812C114.883 88.6059 114.824 88.7366 114.776 88.8613C114.455 89.574 114.128 90.2867 113.831 91.0113C113.356 92.1813 112.976 93.375 112.916 94.6341C112.803 96.8732 113.73 99.0232 114.663 101.06C115.596 103.097 116.589 105.188 116.648 107.433Z"
          fill="url(#paint5_linear)"
        />
        <path
          d="M116.82 111.163C116.82 111.163 124.064 89.0573 139.218 84.9771C139.218 84.9771 124.938 90.3045 118.55 111.163H116.82Z"
          fill="#C2C2C2"
        />
        <path
          d="M135.843 86.2302C135.843 86.2302 144.37 80.986 153.7 87.9764C153.7 87.9764 142.552 91.1419 135.843 86.2302Z"
          fill="#C2C2C2"
        />
        <path
          d="M128.967 91.9199C128.967 91.9199 135.878 86.9845 131.219 75.8961C131.219 75.8961 125.633 82.5123 128.967 91.9199Z"
          fill="#C2C2C2"
        />
        <path
          d="M116.82 111.163C116.82 111.163 121.759 96.1011 132.081 93.3216C132.081 93.3216 122.353 96.9504 117.997 111.163H116.82Z"
          fill="#C2C2C2"
        />
        <path
          d="M130.679 93.6601C130.679 93.6601 137.18 91.5933 142.201 97.7403C142.201 97.7403 134.31 98.0016 130.679 93.6601Z"
          fill="#C2C2C2"
        />
        <path
          d="M124.076 99.2785C124.076 99.2785 127.374 94.5272 121.83 88.4812C121.83 88.4812 119.768 94.0105 124.076 99.2785Z"
          fill="#C2C2C2"
        />
        <path
          d="M75.5133 111.163H62.083C56.1998 105.877 52.0043 99.6055 49.0092 93.4525C47.0482 89.4258 45.6041 85.4525 44.5404 81.8415C44.481 81.6396 44.4156 81.4317 44.3621 81.2298C44.2551 80.8616 44.1541 80.4993 44.059 80.1429C43.9224 79.6559 43.8035 79.1748 43.6847 78.7057C43.6015 78.3671 43.5183 78.0345 43.441 77.7079C43.3935 77.5059 43.3459 77.31 43.2984 77.114C43.2568 76.9239 43.2152 76.7339 43.1736 76.5497C43.0785 76.0984 42.9834 75.6589 42.8943 75.2253C42.8349 74.9343 42.7754 74.6492 42.7219 74.3701C42.6863 74.18 42.6506 73.9959 42.615 73.8177C42.609 73.7702 42.5971 73.7346 42.5912 73.693C41.7592 69.2327 41.6226 66.3701 41.6226 66.3701C41.8068 66.4116 41.991 66.4532 42.1693 66.5007C42.4189 66.5601 42.6566 66.6255 42.9062 66.6908C43.1142 66.7442 43.3221 66.8036 43.5301 66.863C43.7381 66.9224 43.9402 66.9818 44.1482 67.0412C44.9683 67.2847 45.7646 67.5579 46.5431 67.843C58.5293 72.3211 65.6308 81.9544 69.8084 91.0175C74.2 100.603 75.3351 109.559 75.5133 111.163Z"
          fill="url(#paint6_linear)"
        />
        <path
          opacity="0.2"
          d="M67.5443 111.163H62.083C56.1998 105.877 52.0043 99.6055 49.0092 93.4525C47.0482 89.4258 45.6041 85.4525 44.5404 81.8415C44.481 81.6396 44.4156 81.4317 44.3621 81.2298C44.2551 80.8616 44.1541 80.4993 44.059 80.1429C43.9224 79.6559 43.8035 79.1748 43.6847 78.7057C43.6015 78.3671 43.5183 78.0345 43.441 77.7079C43.3935 77.5059 43.3459 77.31 43.2984 77.114C43.2568 76.9239 43.2152 76.7339 43.1736 76.5497C43.0785 76.0984 42.9834 75.6589 42.8943 75.2253C42.8349 74.9343 42.7754 74.6492 42.7219 74.3701C42.6863 74.18 42.6506 73.9959 42.615 73.8177C42.609 73.7702 42.5971 73.7346 42.5912 73.693C41.7652 69.2327 41.6226 66.3701 41.6226 66.3701C41.8068 66.4116 41.9851 66.4532 42.1633 66.4948C42.4129 66.5542 42.6506 66.6195 42.9002 66.6848C43.1082 66.7383 43.3162 66.7977 43.5242 66.8571C43.7322 66.9165 43.9342 66.9759 44.1422 67.0353C44.9623 67.2788 45.7586 67.552 46.5371 67.837C46.9887 71.8697 48.4387 81.1407 52.9017 91.0115C56.0453 97.9781 60.6924 105.242 67.5443 111.163Z"
          fill="url(#paint7_linear)"
        />
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M41.6162 66.3639C41.6162 66.3639 59.2183 83.231 69.3029 112.267"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M51.6831 78.4441C51.6831 78.4441 47.1667 77.6957 43.4585 77.8145"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M56.2888 85.2741C56.2888 85.2741 56.0689 76.1278 55.124 72.4158"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M59.9077 91.3736C59.9077 91.3736 54.4405 91.3558 48.3374 92.0447"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M63.5566 98.3877C63.5566 98.3877 66.5101 88.5644 64.5372 81.9185"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M66.7356 105.503C66.7356 105.503 62.3559 104.463 55.2485 103.697"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M68.2153 109.262C68.2153 109.262 72.2147 101.268 71.9473 96.309"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M60.3415 111.104C60.3415 111.104 60.3415 79.3004 25.3335 80.2091C25.3335 80.2091 30.6403 100.96 48.3671 111.104H60.3415Z"
          fill="url(#paint8_linear)"
        />
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M25.3335 80.2084C25.3335 80.2084 47.6124 90.3584 54.5831 111.104"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M36.3688 87.1152C36.3688 87.1152 32.3873 86.7292 27.9897 87.4062"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M42.145 92.0981C42.145 92.0981 41.8241 84.8286 39.6016 82.0254"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M47.3567 97.8888C47.3567 97.8888 39.7561 97.1642 34.479 98.5302"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M50.7682 102.866C50.7682 102.866 52.2836 94.8123 50.1323 87.9645"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.5"
            d="M53.442 108.11C53.442 108.11 48.6641 106.703 42.4897 107.029"
            stroke="#FEFEFE"
            stroke-width="0.765"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          opacity="0.2"
          d="M25.3335 80.208C25.3335 80.208 30.6343 100.959 48.3671 111.103H53.2163C36.1847 101.357 30.6224 81.8353 30.2005 80.303C28.6554 80.1961 27.039 80.1605 25.3335 80.208Z"
          fill="url(#paint9_linear)"
        />
        <path
          d="M62.0889 111.103C62.0889 111.103 52.0577 80.4812 31.0684 74.8331C31.0684 74.8331 50.8454 82.2154 59.6999 111.103H62.0889Z"
          fill="#C2C2C2"
        />
        <path
          d="M35.7332 76.5673C35.7332 76.5673 23.9193 69.3097 11 78.9905C11.0059 78.9846 26.4508 83.3676 35.7332 76.5673Z"
          fill="#C2C2C2"
        />
        <path
          d="M45.259 84.4485C45.259 84.4485 35.6854 77.6126 42.1391 62.2481C42.1391 62.2481 49.8764 71.4121 45.259 84.4485Z"
          fill="#C2C2C2"
        />
        <path
          d="M62.4455 111.103C62.4455 111.103 56.277 92.2763 43.3696 88.8019C43.3696 88.8019 55.5342 93.3394 60.9717 111.103H62.4455Z"
          fill="#C2C2C2"
        />
        <path
          d="M45.1168 89.2235C45.1168 89.2235 36.9873 86.6341 30.7119 94.3253C30.7179 94.3193 40.5826 94.6519 45.1168 89.2235Z"
          fill="#C2C2C2"
        />
        <path
          d="M53.3773 96.2437C53.3773 96.2437 49.2531 90.2986 56.1822 82.7499C56.1822 82.7499 58.7553 89.6572 53.3773 96.2437Z"
          fill="#C2C2C2"
        />
        <path
          d="M113.593 111.163H96.449C92.0098 107.011 87.9094 102.61 87.9094 102.61C84.2963 107.13 83.0127 108.936 81.3547 111.163H64.6797C66.8487 103.881 69.7072 94.4025 71.2285 89.3899C71.3057 89.1108 71.3889 88.8554 71.4602 88.6119C71.9713 86.937 72.2744 85.9333 72.2744 85.9333C76.1192 87.2696 79.8096 88.113 83.2623 88.6119C90.5182 89.6809 96.6748 89.2414 100.775 88.6119C104.228 88.0833 106.236 87.43 106.236 87.43C106.284 87.7863 106.343 88.1842 106.427 88.6119C106.629 89.675 106.95 90.9578 107.348 92.3832C108.911 97.9719 111.68 105.758 113.593 111.163Z"
          fill="#6B6B6B"
        />
        <path
          d="M91.1066 46.7885C88.6345 46.7885 86.6318 44.787 86.6318 42.3164V27.1597H95.5814V42.3164C95.5814 44.787 93.5788 46.7885 91.1066 46.7885Z"
          fill="#D3D3D3"
        />
        <path
          d="M86.9348 35.0172C82.3649 34.6727 78.936 30.6935 79.2807 26.1263L80.2315 13.47L96.7877 14.7113L95.8369 27.3676C95.4922 31.9348 91.5047 35.3616 86.9348 35.0172Z"
          fill="#D3D3D3"
        />
        <path
          d="M79.9762 23.917C81.1938 23.917 82.1809 22.9305 82.1809 21.7135C82.1809 20.4966 81.1938 19.5101 79.9762 19.5101C78.7586 19.5101 77.7715 20.4966 77.7715 21.7135C77.7715 22.9305 78.7586 23.917 79.9762 23.917Z"
          fill="#D3D3D3"
        />
        <path
          d="M102.748 14.9191C103.081 10.4707 99.7471 6.59247 95.2901 6.25988L72.4585 4.54347C71.3651 8.92655 74.479 13.0305 78.7815 13.3571L94.8503 14.5628L93.7628 29.0305C92.1108 29.6244 89.6387 30.9489 88.1946 33.7581C88.1946 33.7581 86.6495 27.8546 79.4174 28.3832C79.4174 28.3832 78.2229 30.248 77.8901 32.8137C77.3612 36.9177 81.9489 39.7447 85.354 37.3928C85.3956 37.3631 85.4313 37.3394 85.4729 37.3097C85.4729 37.3097 94.886 38.842 95.5159 30.9786L95.5575 30.9845L95.7358 28.6029C99.5747 26.7618 102.136 23.0142 102.451 18.7736L102.706 15.4061C102.712 15.323 102.712 15.2458 102.712 15.1626H102.724L102.748 14.9191Z"
          fill="#575757"
        />
        <path
          d="M48.5749 47.4002C47.63 47.1151 47.0952 46.1233 47.3804 45.179L52.919 26.8152C53.2042 25.8708 54.1966 25.3363 55.1415 25.6214C56.0864 25.9065 56.6212 26.8983 56.336 27.8426L50.7974 46.2064C50.5122 47.1508 49.5138 47.6793 48.5749 47.4002Z"
          fill="#7B7B7B"
        />
        <path
          d="M57.1085 30.6578C52.5862 29.1493 39.1261 25.5205 27.229 30.8954L32.4823 4.10992C32.4823 4.10992 36.7431 14.6638 60.0501 19.7536C61.1554 19.9971 62.0052 20.882 62.1895 21.9986C62.5044 23.9229 62.4688 27.0112 60.0739 29.8501C59.3548 30.6994 58.1722 31.0142 57.1085 30.6578Z"
          fill="url(#paint10_linear)"
        />
        <path
          d="M33.1122 18.4826C31.5433 25.5679 28.3046 31.0319 25.4819 31.6437C25.1431 31.7268 24.8163 31.7328 24.4894 31.6556C21.4765 30.9904 20.4603 24.0178 22.2075 16.0772C23.9605 8.13659 27.8173 2.23903 30.8302 2.90421C31.4067 3.02893 31.9058 3.38528 32.3278 3.93762C34.1284 6.25982 34.5265 12.0564 33.1122 18.4826Z"
          fill="#909090"
        />
        <path
          d="M33.7243 14.8775C33.5817 16.0416 33.3856 17.2472 33.1122 18.4825C32.6546 20.5553 32.0485 22.4855 31.3651 24.196C29.6893 28.3474 27.4786 31.2101 25.4819 31.6377C23.9606 29.6778 23.4376 25.2532 24.1626 20.0683V20.0624C24.1686 20.0208 24.1686 19.9851 24.1805 19.9495C24.3112 19.0171 24.4835 18.0609 24.6975 17.0869C24.9292 16.0356 25.2026 15.02 25.4997 14.046C25.5057 14.0163 25.5175 13.9926 25.5235 13.9688C27.2409 8.44542 29.9389 4.44244 32.3278 3.92574C33.7837 5.81438 34.3245 9.95989 33.7243 14.8775Z"
          fill="#7B7B7B"
        />
        <path
          d="M52.1167 18.6251C51.8493 20.7513 51.1303 24.3207 49.2048 27.7595C48.8602 28.3712 49.193 29.1433 49.8764 29.2977C51.4987 29.66 54.2026 30.3074 56.3479 31.0023C57.9346 31.519 59.7055 31.0854 60.8108 29.8382C62.237 28.2287 63.5206 25.4848 62.3202 21.2146C62.035 20.2109 61.2149 19.4506 60.2047 19.1893C58.6477 18.7914 56.1874 18.1262 54.1075 17.4016C53.2102 17.0928 52.2415 17.6748 52.1167 18.6251Z"
          fill="url(#paint11_linear)"
        />
        <path
          d="M33.7243 14.8775C33.5817 16.0416 33.3856 17.2472 33.1122 18.4826C32.6547 20.5553 32.0485 22.4855 31.3651 24.196C30.2598 22.8894 26.0465 20.9117 24.1627 20.0742V20.0683C24.0795 20.0327 24.0022 20.003 23.9309 19.9733C23.919 19.9673 23.919 19.9614 23.9071 19.9614C23.4555 19.7595 23.1643 19.32 23.1405 18.827C23.0573 17.069 23.8239 15.4833 24.3528 14.6043C24.5786 14.2361 24.9649 14.0044 25.3809 13.9866C25.4284 13.9748 25.47 13.9748 25.5235 13.9807C25.5532 13.9807 25.5889 13.9807 25.6186 13.9866C29.8379 14.4974 33.5461 14.8597 33.7243 14.8775Z"
          fill="url(#paint12_linear)"
        />
        <path
          d="M26.0761 17.2769C25.7076 18.9517 24.6974 20.1514 23.8238 19.9554C22.9503 19.7594 22.5402 18.2509 22.9146 16.5761C23.2831 14.9012 24.2933 13.7015 25.1669 13.8975C26.0404 14.0876 26.4505 15.6021 26.0761 17.2769Z"
          fill="#575757"
        />
        <path
          d="M15.8195 8.58799L9.82934 0L6.74512 3.18338L14.8627 9.66297L15.8195 8.58799Z"
          fill="url(#paint13_linear)"
        />
        <path
          d="M14.1375 13.4818L0.61209 10.2747L0 14.4618L13.7928 15.8693L14.1375 13.4818Z"
          fill="url(#paint14_linear)"
        />
        <path
          d="M12.9725 19.5991L2.66797 23.5605L4.28436 26.5182L13.9233 21.5769L12.9725 19.5991Z"
          fill="url(#paint15_linear)"
        />
        <path
          d="M51.534 48.7781C52.0154 47.4181 52.574 46.0818 53.2039 44.7811C54.4697 44.4901 55.3254 43.6942 55.9435 42.5599C56.5615 41.4196 56.8408 40.1367 57.1142 38.8717C57.2568 38.2243 57.3935 37.571 57.5361 36.9236C57.7262 36.0446 57.9164 35.1241 57.643 34.2629C57.5242 33.8768 57.2687 33.4849 56.8764 33.3898C56.4545 33.2889 56.0267 33.5621 55.7414 33.8947C54.5885 35.2191 54.8144 37.3691 53.6139 38.646C52.9543 39.3468 51.9797 39.6556 51.0289 39.8219C50.0781 39.9882 49.1035 40.0417 48.1943 40.3683C48.1824 40.3743 48.1764 40.3743 48.1646 40.3802C46.9642 40.8197 46.1738 42.0016 46.1678 43.2844C46.156 45.2028 46.4353 46.741 47.3445 48.2852C47.5703 48.6653 47.9982 48.8613 48.4379 48.8375C49.1213 48.796 49.8879 48.986 50.607 48.8435C50.9695 48.7663 51.4152 49.1167 51.534 48.7781Z"
          fill="#D3D3D3"
        />
        <path
          d="M45.9362 34.1325C46.7265 33.5564 47.9151 33.5089 48.8362 33.4554C50.2327 33.3723 51.6589 33.6633 52.9009 34.3225C53.9765 34.8986 54.9749 35.8727 55.0165 37.0902C55.0343 37.5653 54.8976 38.0345 54.7669 38.4977C54.6718 38.8185 54.5827 39.1451 54.4876 39.4658C54.3212 40.0419 54.1489 40.6299 53.8399 41.1466C53.2575 42.1206 52.2116 42.768 51.1062 43.0174C49.995 43.2609 48.8302 43.1303 47.7427 42.8036C46.8513 42.5304 45.9659 42.1028 45.3776 41.3782C44.2009 39.9291 44.5634 37.7672 44.9378 36.0924C45.0448 35.6054 45.1696 35.1124 45.431 34.6908C45.5558 34.4651 45.7341 34.281 45.9362 34.1325Z"
          fill="#D3D3D3"
        />
        <path
          d="M95.5751 42.3223H86.6314C86.6314 42.3223 82.7212 44.591 78.591 51.9021C73.213 54.4856 65.7966 57.7759 59.5033 59.5636C56.1101 60.5317 52.6693 58.1263 52.4494 54.6103C52.3544 53.084 52.3306 51.2785 52.4375 49.1938C52.5505 46.9607 50.2625 45.2978 48.2183 46.2005C48.1826 46.2183 48.147 46.2362 48.1113 46.248C47.2199 46.6697 46.5959 47.5071 46.4236 48.4693C46.2097 49.6868 45.9066 51.7239 45.764 54.2302C45.2826 62.7885 52.182 69.9689 60.7572 69.9095C64.1742 69.8858 68.0607 69.6304 72.1908 68.9652C71.9828 69.8383 71.7808 70.7351 71.5847 71.6675C70.6457 76.1931 69.9029 81.378 69.4751 87.2934C69.4751 87.2934 80.1302 104.232 108.762 91.7715C108.774 91.7834 105.666 53.1196 95.5751 42.3223Z"
          fill="url(#paint16_linear)"
        />
        <path
          d="M88.0341 64.9325C88.0341 64.9325 82.0617 70.444 71.5908 71.6794C71.7929 70.6875 72.0127 69.7313 72.2326 68.8048V68.7989C72.2386 68.7989 82.3232 67.0053 88.0341 64.9325Z"
          fill="#7D7D7D"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="106.792"
        y1="89.0685"
        x2="131.617"
        y2="89.0685"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="112.802"
        y1="89.0696"
        x2="131.615"
        y2="89.0696"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="115.591"
        y1="97.2875"
        x2="147.017"
        y2="97.2875"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="121.985"
        y1="97.2882"
        x2="147.016"
        y2="97.2882"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="106.35"
        y1="107.867"
        x2="108.932"
        y2="77.954"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="110.323"
        y1="111.08"
        x2="114.862"
        y2="58.4923"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="41.6138"
        y1="88.7659"
        x2="75.5135"
        y2="88.7659"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1="41.6179"
        y1="88.768"
        x2="67.5426"
        y2="88.768"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint8_linear"
        x1="60.3392"
        y1="95.6471"
        x2="25.3327"
        y2="95.6471"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint9_linear"
        x1="53.2167"
        y1="95.6467"
        x2="25.3342"
        y2="95.6467"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint10_linear"
        x1="27.2289"
        y1="17.5007"
        x2="62.3347"
        y2="17.5007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C0C0C0" />
        <stop offset="1" stop-color="#747474" />
      </linearGradient>
      <linearGradient
        id="paint11_linear"
        x1="49.0717"
        y1="24.2717"
        x2="62.8013"
        y2="24.2717"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint12_linear"
        x1="23.1315"
        y1="19.0841"
        x2="33.725"
        y2="19.0841"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint13_linear"
        x1="6.63641"
        y1="3.78654"
        x2="16.3753"
        y2="5.57081"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint14_linear"
        x1="-0.056455"
        y1="14.0421"
        x2="13.9589"
        y2="12.1666"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint15_linear"
        x1="3.32868"
        y1="25.1017"
        x2="13.551"
        y2="20.7093"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0108" stop-color="#434343" />
        <stop offset="0.9946" stop-color="#6A6A6A" />
      </linearGradient>
      <linearGradient
        id="paint16_linear"
        x1="63.9889"
        y1="53.9994"
        x2="107.423"
        y2="81.3076"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C0C0C0" />
        <stop offset="1" stop-color="#747474" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="159.375" height="120" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: "EmptyStateSVG"
};
</script>
